
import { defineComponent, computed, PropType } from 'vue'

type Bg = {
  primary?: string;   // ejemplo: "51 16 107"
  secondary?: string; // ejemplo: "39 70 247"
}

export default defineComponent({
  props: {
    title: { type: String, required: true },
    subTitle: { type: String, default: '' },
    bg: { type: Object as PropType<Bg>, default: () => ({}) },
    img: { type: String, default: '' }
  },

  setup(props) {
    const REPO = process.env.VUE_APP_REPO || ''

    const bgStyle = computed(() => {
      const primary = props.bg?.primary ?? '51 0 0'
      const secondary = props.bg?.secondary ?? '39 0 247'

      const imageUrl = props.img ? `${REPO}/${props.img}` : ''

      return {
        background: imageUrl
        ? `linear-gradient(180deg, rgb(${secondary}), rgba(${primary}, 0.2)), url('${imageUrl}')`
        : `linear-gradient(90deg, rgb(${primary}), rgba(${secondary}, 0.2))`,
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
        backgroundRepeat: 'no-repeat'
      }
    })

    return { bgStyle }
  }
})
